import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.css']
})
export class DrawerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
